<script lang="ts" setup>

  import { useI18n } from 'vue-i18n'

  const { t } = useI18n()
  const router = useRouter()
  const route = useRoute()

  function onButtonClick() {
    router.push({ query: { ...route.query, modal: 'login' } })
  }

</script>

<template>
  <div class="c-forbidden-page">
    <Paper>
      <slot name="icon" />
      <div class="title">
        <slot name="title" />
      </div>
      <div class="subtitle">
        <slot name="subtitle" />
      </div>
      <ButtonAndLink
        class="form-bottom"
        @button-click="onButtonClick"
      >
        <template #button>
          <span>{{ t("authentication.connect") }}</span>
        </template>
        <template #caption>
          {{ t("authentication.no-account") }}
        </template>
        <template #link>
          <NuxtLink to="/register">
            {{ t("authentication.register") }}
          </NuxtLink>
        </template>
      </ButtonAndLink>
    </Paper>
  </div>
</template>

<style>
.c-forbidden-page {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;

  .c-paper {
    display: flex;
    width: 100%;
    flex: 1 1;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    padding: 1.5em 1.5em 4.5em;
    margin: 0;

    .c-icon {
      width: 3em;
      height: 3em;
      margin-top: 3em;
      color: var(--color-primary);
    }

    .title {
      color: var(--color-secondary);
      font-family: Bariol, sans-serif;
      font-size: 2rem;
      font-weight: 700;
    }

    .subtitle {
      justify-content: center;
      color: var(--color-secondary);
      font-family: Open-Sans, sans-serif;
      font-size: 1.125rem;
      font-weight: 600;
      line-height: 1.33;
      text-align: center;
    }
  }
}

@media all and (width >= 1024px) {
  .c-forbidden-page {
    .c-paper {
      max-width: 25rem;
      height: 30em;
      min-height: 30rem;
      max-height: 33rem;
      justify-content: space-between;
      margin: auto;
    }
  }
}

</style>
